<template>
  <div class="study">
    <header class="study-title">精准教学
      <span class="study-title__text">(今日新增数)</span>
    </header>
    <div class="study-number">
      <div :class="{'study-number__text': index!==3,
      'study-number__bottom': index === 3}"
        v-for="(item, index) in todayAdd"
        :key="index"
      >{{item}}</div>
    </div>
    <p class="study-add">累计:  {{Number(addNumber).toLocaleString()}}</p>
    <div class="study-issue">
      <div class="study-issue__number">
        <p>今日发布练习数</p>
        <div>{{Number(issueNumber).toLocaleString()}}</div>
      </div>
      <div class="study-issue__number">
        <p>今日发布测评数</p>
        <div>{{Number(testNumber).toLocaleString()}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccurateStudy',
  data() {
    return {
      issueNumber: 731,
      testNumber: 631,
      addNumber: 12789376,
      timer: '',
    };
  },
  computed: {
    todayAdd() {
      const addnumber = this.issueNumber + this.testNumber;
      const n = this.PrefixInteger(addnumber, 6);
      return this.insertStr(n, 3, ',');
    },
  },
  mounted() {
    this.getData();
    this.timer = setInterval(() => {
      this.issueNumber = this.accumulate(this.issueNumber);
      this.testNumber = this.accumulate(this.testNumber);
      sessionStorage.setItem('accurateStudyData', JSON.stringify({
        issueNumber: this.issueNumber,
        testNumber: this.testNumber,
        addNumber: this.addNumber,
      }));
    }, 60000);
  },
  methods: {
    PrefixInteger(num, length) {
      this.addNumber += num;
      return (`0000000000000000${num}`).substr(-length);
    },
    accumulate(num) {
      console.log(num, 'num');
      return num + Math.ceil(Math.random() * 50 + 10);
    },
    insertStr(soure, start, newStr) {
      return soure.slice(0, start) + newStr + soure.slice(start);
    },
    getData() {
      const datas = JSON.parse(sessionStorage.getItem('accurateStudyData') || '{}');
      Object.keys(datas).forEach((key) => {
        this[key] = Number(datas[key]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .study {
    box-sizing: border-box;
    width: 100%;
    height: 259px;
    padding: 20px;
    margin-top: 24px;
    color: #f5f5f5;
    background: url('../../images/exhibition-study.png') no-repeat left top / 100% 100%;
    &-title {
      line-height: 24px;
      font-size: 20px;
      text-indent: 32px;
      margin-bottom: 20px;
      background: url('../../images/exhibition-icon.png') no-repeat left top / 24px;
      &__text {
        font-size: 15px;
        color: #E3E2FF;
      }
    }
    &-number {
      display: flex;
      font-size: 32px;
      text-align: center;
      &__text {
        width: 30px;
        height: 38px;
        line-height: 38px;
        margin-right: 10px;
        color: #f5f5f5;
        background: linear-gradient(180deg, #0A54EA 0%, #4D07CF 100%);
        border-radius: 2px;
        border: 1px solid rgba(112, 65, 255, 1);
        border-image: linear-gradient(180deg, rgba(55, 110, 255, 1), rgba(112, 65, 255, 1)) 1 1;
      }
      &__bottom {
        margin-right: 10px;
      }
    }
    &-add {
      font-size: 15px;
      margin-top: 14px;
      margin-bottom: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FCE204;
      line-height: 21px;
    }
    &-issue {
      display: flex;
      &__number {
        width: 150px;
        height: 80px;
        background: rgba(131, 92, 255, 0.2);
        border-radius: 4px;
        margin-right: 44px;
        p {
          font-size: 15px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #E3E2FF;
          margin-top: 12px;
          text-align: center;
        }
        div {
          text-align: center;
          font-size: 22px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          margin-top: 6px;
          color: #00DEFF;
        }
      }
    }
  }
</style>
